import { ReschedulableBooking } from '@kouto/types';
import { useAppState } from 'AppProvider';
import InfoCircleIcon from 'assets/bx-info-circle';
import {
  ResourceHeading2,
  ResourceParagraph,
} from 'components/theme/Typography/ResourceTypography';
import { Wrapper } from 'components/theme/Wrapper';
import {
  LayoutWrapper,
  Label,
  Header,
  NavigationHeaderWrapper,
  RescheduleMessage,
  Main,
} from 'features/GuestReschedule/components/Layout';
import NavigationHeader from 'features/GuestReschedule/components/NavigationHeader';
import ReservationItem from 'features/GuestReschedule/components/ReservationItem';
import ReservationItemList from 'features/GuestReschedule/components/ReservationItemList';
import useGuestReschedule from 'features/GuestReschedule/hooks/useGuestReschedule';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface RescheduleNotAllowedProps {
  readonly booking?: ReschedulableBooking | null;
}

const RescheduleNotAllowed = ({
  booking = null,
}: RescheduleNotAllowedProps) => {
  const { t } = useTranslation();
  const { settings: brandSettings } = useAppState(
    (state: Record<string, unknown>) => state.brand,
  );

  const { bookings } = useGuestReschedule();

  // If there are multiple bookings, we don't show the reschedule policy notes
  const notes = bookings.length > 1 ? null : bookings[0]?.reschedulePolicyNotes;

  const brandEmail =
    typeof brandSettings?.brandEmail === 'string'
      ? brandSettings?.brandEmail
      : t('theHotel');

  return (
    <Wrapper>
      <LayoutWrapper>
        {booking && (
          <NavigationHeaderWrapper>
            <NavigationHeader />
          </NavigationHeaderWrapper>
        )}
        <Header>
          <ResourceHeading2 fontSize="28px" className="title">
            {t('reviewReschedule')}
          </ResourceHeading2>
          {notes && (
            <ResourceParagraph
              className="subtitle"
              fontSize="16px"
              opacity="0.7"
              fontWeight="400"
              lineHeight="20px"
            >
              {notes}
            </ResourceParagraph>
          )}
        </Header>
        <Main>
          {booking ? (
            <ReservationItem booking={booking} />
          ) : (
            <ReservationItemList isSelectable={false} />
          )}
          <RescheduleMessage>
            <InfoCircleIcon
              scale={1}
              color="var(--way-colors-primaryTextColor)"
            />
            <Label>
              {t('thisReservationCanNoLongerBeRescheduledPleaseEmail', {
                brandEmail,
              })}
            </Label>
          </RescheduleMessage>
        </Main>
      </LayoutWrapper>
    </Wrapper>
  );
};

export default RescheduleNotAllowed;
